module.exports = __webpack_public_path__ + "static/media/craftBunny.7e85050d.jpeg";